//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const RhombusIcon = require("@/assets/bindCard/rhombus@2x.png");
const CloseIcon = require("@/assets/bindCard/close@2x.png");

export default {
    name: "creditComplicance",
    data() {
        return {
            RhombusIcon,
            CloseIcon,
        };
    },
    props: {
        showCreditComplianceDialog: Boolean,
    },
    methods: {
        closeDialog() {
            this.$emit("close-dialog");
        },
    },
};
